// @ts-nocheck
import {ConfEnv} from "../../../config/config";
import privateRequest from "../../../Infra/http/private.request";
import publicRequest from "../../../Infra/http/public.request";

export const getProviderGamesService = async (provider: string, isAuthenticated = false) => {
  const url = `${ConfEnv.API_GAME_FEED.PROVIDER_FEED}/${encodeURIComponent(provider)}`;
  return isAuthenticated ? privateRequest.get(url) : publicRequest.get(url);
};

export const toggleProviderFollowService = async (providerName: string) => {
  return privateRequest.post(ConfEnv.API_GAME_FEED.TOGGLE_FOLLOW, {
    provider_name: providerName,
  });
};
